import React from 'react'
import { Card,Tooltip } from 'components/ui'
import ItemDropdown from './ItemDropdown'
import Members from './Members'
import ProgressionBar from './ProgressionBar'
import { Link } from 'react-router-dom'
import { 
	HiOutlineCalendar, 
HiOutlineClipboardCheck,
HiOutlineTruck

} from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'

const formatDate = (date) => {
    var formatDate = new Date(date)
    return (
      <div>
		
        {formatDate.toLocaleDateString()}
      </div>
    )
  }

const GridItem = ({data}) => {

	const {
		Route, 
		DeliveryDate, 
		Routeid, 
		progression,
		Trucks,
		member,
		Details,
		Drivers,
		SalesRep,
		_id,
	} = data


		const navigate = useNavigate()
	
		const onEdit = () => {
			navigate(`/app/logistics/planning-edit/${_id}`)
		}
	return (
		<Card bodyClass="h-full">
			<div className="flex flex-col justify-between h-full">
				<div className="flex justify-between">
					<a href="#" onClick={onEdit}><span style={{fontSize:12, fontWeight:'bold'}} >{Route}</span></a>	
					
				</div>
				<div className="flex"><HiOutlineCalendar style={{marginTop:3, marginRight:3}}/>{formatDate(DeliveryDate)}</div>
				<div className="flex"><HiOutlineTruck style={{marginTop:3, marginRight:3}} />{Trucks.Name}</div>
				<div className="mt-3">
					<div className="flex items-center justify-between mt-2">
						<Members members={member} Drivers={Drivers} SalesReps={SalesRep}/>
						<div className="flex items-center rounded-full font-semibold text-xs">
											<ItemDropdown Routeid={Routeid} _id={_id} />

						</div>
					</div>
				</div>
			</div>
		</Card>
	)
}

export default GridItem
